import { lazy } from 'react';

// project import
import MainLayout from 'layout/MainLayout';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
// render - dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const DashboardAnalytics = Loadable(lazy(() => import('pages/dashboard/analytics')));
// const Questionlist =  Loadable(lazy(() => import('pages/offer/questionlist')));
// render - widget
const WidgetStatistics = Loadable(lazy(() => import('pages/widget/statistics')));
const WidgetData = Loadable(lazy(() => import('pages/widget/data')));
const WidgetChart = Loadable(lazy(() => import('pages/widget/chart')));

// render - applications
const AppChat = Loadable(lazy(() => import('pages/apps/chat')));
const AppCalendar = Loadable(lazy(() => import('pages/apps/calendar')));
const AppCustomerList = Loadable(lazy(() => import('pages/apps/customer/list')));

const UserProfile = Loadable(lazy(() => import('pages/apps/profiles/user')));
const UserTabPersonal = Loadable(lazy(() => import('sections/apps/profiles/user/TabPersonal')));
const UserTabPayment = Loadable(lazy(() => import('sections/apps/profiles/user/TabPayment')));
const UserTabPassword = Loadable(lazy(() => import('sections/apps/profiles/user/TabPassword')));
const UserTabSettings = Loadable(lazy(() => import('sections/apps/profiles/user/TabSettings')));

const AccountProfile = Loadable(lazy(() => import('pages/apps/profiles/account')));
const AccountTabProfile = Loadable(lazy(() => import('sections/apps/profiles/account/TabProfile')));
const AccountTabPersonal = Loadable(lazy(() => import('sections/apps/profiles/account/TabPersonal')));
const AccountTabAccount = Loadable(lazy(() => import('sections/apps/profiles/account/TabAccount')));
const AccountTabPassword = Loadable(lazy(() => import('sections/apps/profiles/account/TabPassword')));
const AccountTabRole = Loadable(lazy(() => import('sections/apps/profiles/account/TabRole')));
const AccountTabSettings = Loadable(lazy(() => import('sections/apps/profiles/account/TabSettings')));
const AddUser = Loadable(lazy(() => import('sections/apps/profiles/account/AddAdminUser')));
const ProfileUserList = Loadable(lazy(() => import('pages/apps/profiles/user-list')));
const ProfileUserCard = Loadable(lazy(() => import('pages/apps/profiles/user-card')));

const AppECommProducts = Loadable(lazy(() => import('pages/apps/e-commerce/product')));
const AppECommProductDetails = Loadable(lazy(() => import('pages/apps/e-commerce/product-details')));
const AppECommProductList = Loadable(lazy(() => import('pages/apps/e-commerce/products-list')));
const AppECommCheckout = Loadable(lazy(() => import('pages/apps/e-commerce/checkout')));
const AppECommAddProduct = Loadable(lazy(() => import('pages/apps/e-commerce/add-product')));
const FaqList = Loadable(lazy(() => import('pages/offer/products-list')));
const OfferList = Loadable(lazy(() => import('pages/user/products-list')));
const OfferAdd = Loadable(lazy(() => import('pages/user/add-product')));
const UserDetails = Loadable(lazy(() => import('pages/user/form')));
const CouponList = Loadable(lazy(() => import('pages/coupon/products-list')));
const CouponAdd = Loadable(lazy(() => import('pages/coupon/add-product')));
const FaqAdd = Loadable(lazy(() => import('pages/offer/add-product')));
const GalleryList = Loadable(lazy(() => import('pages/gallery/products-list')));
const GalleryAdd = Loadable(lazy(() => import('pages/gallery/add-product')));
const SessionList = Loadable(lazy(() => import('pages/session-table/session-list')));
const AddSession = Loadable(lazy(() => import('pages/session-table/add-session')));
const RoomList = Loadable(lazy(() => import('pages/room-category/room-list')));
const AddRoom = Loadable(lazy(() => import('pages/room-category/add-room')));
const Setting = Loadable(lazy(() => import('pages/setting/settingList')));
const AddSetting = Loadable(lazy(() => import('pages/setting/addSetting')));
// render - forms & tables
const AvailabilityList = Loadable(lazy(() => import('pages/dateselect/products-list')));
const AvailabilityAdd = Loadable(lazy(() => import('pages/dateselect/add-product')));
const ProfileList = Loadable(lazy(() => import('pages/all-profile/ProfileList')));
const CancelList = Loadable(lazy(() => import('pages/all-profile/CancelList')));
const PendingList = Loadable(lazy(() => import('pages/all-profile/PendingList')));
const BookingDateList = Loadable(lazy(() => import('pages/all-profile/BookingList')));
const AddProfile = Loadable(lazy(() => import('pages/all-profile/add-product')));
const FormsValidation = Loadable(lazy(() => import('pages/forms/validation')));
const FormsWizard = Loadable(lazy(() => import('pages/forms/wizard')));

const FormsLayoutBasic = Loadable(lazy(() => import('pages/forms/layouts/basic')));
const FormsLayoutMultiColumn = Loadable(lazy(() => import('pages/forms/layouts/multi-column')));
const FormsLayoutActionBar = Loadable(lazy(() => import('pages/forms/layouts/action-bar')));
const FormsLayoutStickyBar = Loadable(lazy(() => import('pages/forms/layouts/sticky-bar')));

const FormsPluginsMask = Loadable(lazy(() => import('pages/forms/plugins/mask')));
const FormsPluginsClipboard = Loadable(lazy(() => import('pages/forms/plugins/clipboard')));
const FormsPluginsRecaptcha = Loadable(lazy(() => import('pages/forms/plugins/re-captcha')));
const FormsPluginsEditor = Loadable(lazy(() => import('pages/forms/plugins/editor')));
const FormsPluginsDropzone = Loadable(lazy(() => import('pages/forms/plugins/dropzone')));

const ReactTableBasic = Loadable(lazy(() => import('pages/tables/react-table/basic')));
const ReactTableSorting = Loadable(lazy(() => import('pages/tables/react-table/sorting')));
const ReactTableFiltering = Loadable(lazy(() => import('pages/tables/react-table/filtering')));
const ReactTableGrouping = Loadable(lazy(() => import('pages/tables/react-table/grouping')));
const ReactTablePagination = Loadable(lazy(() => import('pages/tables/react-table/pagination')));
const ReactTableRowSelection = Loadable(lazy(() => import('pages/tables/react-table/row-selection')));
const ReactTableExpanding = Loadable(lazy(() => import('pages/tables/react-table/expanding')));
const ReactTableEditable = Loadable(lazy(() => import('pages/tables/react-table/editable')));
const ReactTableDragDrop = Loadable(lazy(() => import('pages/tables/react-table/drag-drop')));
const ReactTableColumnHiding = Loadable(lazy(() => import('pages/tables/react-table/column-hiding')));
const ReactTableUmbrella = Loadable(lazy(() => import('pages/tables/react-table/umbrella')));

// render - charts & map
const ChartApexchart = Loadable(lazy(() => import('pages/charts/apexchart')));
const ChartOrganization = Loadable(lazy(() => import('pages/charts/org-chart')));

// table routing
const MuiTableBasic = Loadable(lazy(() => import('pages/tables/mui-table/basic')));
const MuiTableDense = Loadable(lazy(() => import('pages/tables/mui-table/dense')));
const MuiTableEnhanced = Loadable(lazy(() => import('pages/tables/mui-table/enhanced')));
const MuiTableDatatable = Loadable(lazy(() => import('pages/tables/mui-table/datatable')));
const MuiTableCustom = Loadable(lazy(() => import('pages/tables/mui-table/custom')));
const MuiTableFixedHeader = Loadable(lazy(() => import('pages/tables/mui-table/fixed-header')));
const MuiTableCollapse = Loadable(lazy(() => import('pages/tables/mui-table/collapse')));

// pages routing
const AuthLogin = Loadable(lazy(() => import('pages/auth/login')));
const AuthRegister = Loadable(lazy(() => import('pages/auth/register')));
const AuthForgotPassword = Loadable(lazy(() => import('pages/auth/forgot-password')));
const AuthResetPassword = Loadable(lazy(() => import('pages/auth/reset-password')));
const AuthCheckMail = Loadable(lazy(() => import('pages/auth/check-mail')));
const AuthCodeVerification = Loadable(lazy(() => import('pages/auth/code-verification')));

const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon')));

const AppContactUS = Loadable(lazy(() => import('pages/contact-us')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));
const PricingPage = Loadable(lazy(() => import('pages/extra-pages/pricing')));
// News Section
const CategoryList = Loadable(lazy(() => import('pages/newscategory/list')));
const AddCategory = Loadable(lazy(() => import('pages/newscategory/form')));
const NewsList = Loadable(lazy(() => import('pages/news-section/list')));
const AddNews = Loadable(lazy(() => import('pages/news-section/add-form')));
const HolidaysList = Loadable(lazy(() => import('pages/holidays/list')));
const AddHolidays = Loadable(lazy(() => import('pages/holidays/form')));
const PackageCategoryList = Loadable(lazy(() => import('pages/package-category/room-list')));
const AddPackageCategory = Loadable(lazy(() => import('pages/package-category/add-room')));
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: 'dashboard',
          children: [
            {
              path: 'default',
              element: <DashboardDefault />
            },
            {
              path: 'analytics',
              element: <DashboardAnalytics />
            }
          ]
        },

        {
          path: 'offer',
          children: [
            {
              path: 'product-list',
              element: <FaqList />
            },
            {
              path: 'add-new-product/:id',
              element: <FaqAdd />
            },
            {
              path: 'add-new-product',
              element: <FaqAdd />
            }
          ]
        },
        {
          path: 'season',
          children: [
            {
              path: 'season-list',
              element: <SessionList />
            },
            {
              path: 'add-season/:id',
              element: <AddSession />
            },
            {
              path: 'add-season',
              element: <AddSession />
            }
          ]
        },
        {
          path: 'package-category',
          children: [
            {
              path: 'package-category-list',
              element: <PackageCategoryList />
            },
            {
              path: 'add-package-category/:id',
              element: <AddPackageCategory />
            },
            {
              path: 'add-package-category',
              element: <AddPackageCategory />
            }
          ]
        },
        {
          path: 'roomcategory',
          children: [
            {
              path: 'room-list',
              element: <RoomList />
            },
            {
              path: 'add-room-category/:id',
              element: <AddRoom />
            },
            {
              path: 'add-room-category',
              element: <AddRoom />
            }
          ]
        },
        {
          path: 'news-topics',
          children: [
            {
              path: 'news-topics-list',
              element: <NewsList />
            },
            {
              path: 'add-news-topics/:id',
              element: <AddNews />
            },
            {
              path: 'add-news-topics',
              element: <AddNews />
            }
          ]
        },
        {
          path: 'categorytopics',
          children: [
            {
              path: 'categorytopics-list',
              element: <CategoryList />
            },
            {
              path: 'add-categorytopics/:id',
              element: <AddCategory />
            },
            {
              path: 'add-categorytopics',
              element: <AddCategory />
            }
          ]
        },
        {
          path: 'holidays',
          children: [
            {
              path: 'holidays-list',
              element: <HolidaysList />
            },
            {
              path: 'add-holidays/:id',
              element: <AddHolidays />
            },
            {
              path: 'add-holidays',
              element: <AddHolidays />
            }
          ]
        },
        {
          path: 'setting',
          children: [
            {
              path: 'setting',
              element: <Setting />
            },
            {
              path: 'add-setting/:id',
              element: <AddSetting />
            },
            {
              path: 'add-setting',
              element: <AddSetting />
            }
          ]
        },
        {
          path: 'availability',
          children: [
            {
              path: 'availability-list',
              element: <AvailabilityList />
            },
            {
              path: 'add-new-availability',
              element: <AvailabilityAdd />
            },
            {
              path: 'add-new-availability/:id',
              element: <AvailabilityAdd />
            }
          ]
        },
        {
          path: 'profile',
          children: [
            {
              path: 'profile-list',
              element: <ProfileList />
            },
            {
              path: 'cancel-list',
              element: <CancelList />
            },
            {
              path: 'bookingdatelist',
              element: <BookingDateList />
            },
            {
              path: 'pendinglist',
              element: <PendingList />
            },
            {
              path: 'add-new-profile',
              element: <AddProfile />
            },
            {
              path: 'add-new-profile/:id',
              element: <AddProfile />
            }
          ]
        },
        {
          path: 'user',
          children: [
            {
              path: 'product-list',
              element: <OfferList />
            },
            {
              path: 'add-new-product/:id',
              element: <OfferAdd />
            },
            {
              path: 'userdetails/:id',
              element: <UserDetails />
            },
            {
              path: 'userdetails',
              element: <UserDetails />
            },
            {
              path: 'add-new-product',
              element: <OfferAdd />
            }
          ]
        },
        {
          path: 'gallery',
          children: [
            {
              path: 'product-list',
              element: <GalleryList />
            },
            {
              path: 'add-new-product/:id',
              element: <GalleryAdd />
            },
            {
              path: 'add-new-product',
              element: <GalleryAdd />
            }
          ]
        },
        {
          path: 'coupon',
          children: [
            {
              path: 'product-list',
              element: <CouponList />
            },
            {
              path: 'add-new-product',
              element: <CouponAdd />
            }
          ]
        },

        {
          path: 'widget',
          children: [
            {
              path: 'statistics',
              element: <WidgetStatistics />
            },
            {
              path: 'data',
              element: <WidgetData />
            },
            {
              path: 'chart',
              element: <WidgetChart />
            }
          ]
        },
        {
          path: 'apps',
          children: [
            {
              path: 'chat',
              element: <AppChat />
            },
            {
              path: 'calendar',
              element: <AppCalendar />
            },
            {
              path: 'customer',
              children: [
                {
                  path: 'list',
                  element: <AppCustomerList />
                }
              ]
            },
            {
              path: 'profiles',
              children: [
                {
                  path: 'account',
                  element: <AccountProfile />,
                  children: [
                    {
                      path: 'basic',
                      element: <AccountTabProfile />
                    },
                    {
                      path: 'personal',
                      element: <AccountTabPersonal />
                    },
                    {
                      path: 'my-account',
                      element: <AccountTabAccount />
                    },
                    {
                      path: 'password',
                      element: <AccountTabPassword />
                    },
                    {
                      path: 'role',
                      element: <AccountTabRole />
                    },
                    {
                      path: 'settings',
                      element: <AccountTabSettings />
                    },
                    {
                      path: 'adduser',
                      element: <AddUser />
                    }
                  ]
                },
                {
                  path: 'user',
                  element: <UserProfile />,
                  children: [
                    {
                      path: 'personal',
                      element: <UserTabPersonal />
                    },
                    {
                      path: 'payment',
                      element: <UserTabPayment />
                    },
                    {
                      path: 'password',
                      element: <UserTabPassword />
                    },
                    {
                      path: 'settings',
                      element: <UserTabSettings />
                    }
                  ]
                },
                {
                  path: 'user-list',
                  element: <ProfileUserList />
                },
                {
                  path: 'user-card',
                  element: <ProfileUserCard />
                }
              ]
            },
            {
              path: 'e-commerce',
              children: [
                {
                  path: 'products',
                  element: <AppECommProducts />
                },
                {
                  path: 'product-details/:id',
                  element: <AppECommProductDetails />
                },
                {
                  path: 'product-list',
                  element: <AppECommProductList />
                },
                {
                  path: 'add-new-product',
                  element: <AppECommAddProduct />
                },
                {
                  path: 'checkout',
                  element: <AppECommCheckout />
                }
              ]
            }
          ]
        },
        {
          path: 'forms',
          children: [
            {
              path: 'validation',
              element: <FormsValidation />
            },
            {
              path: 'wizard',
              element: <FormsWizard />
            },
            {
              path: 'layout',
              children: [
                {
                  path: 'basic',
                  element: <FormsLayoutBasic />
                },
                {
                  path: 'multi-column',
                  element: <FormsLayoutMultiColumn />
                },
                {
                  path: 'action-bar',
                  element: <FormsLayoutActionBar />
                },
                {
                  path: 'sticky-bar',
                  element: <FormsLayoutStickyBar />
                }
              ]
            },
            {
              path: 'plugins',
              children: [
                {
                  path: 'mask',
                  element: <FormsPluginsMask />
                },
                {
                  path: 'clipboard',
                  element: <FormsPluginsClipboard />
                },
                {
                  path: 're-captcha',
                  element: <FormsPluginsRecaptcha />
                },
                {
                  path: 'editor',
                  element: <FormsPluginsEditor />
                },
                {
                  path: 'dropzone',
                  element: <FormsPluginsDropzone />
                }
              ]
            }
          ]
        },
        {
          path: 'tables',
          children: [
            {
              path: 'react-table',
              children: [
                {
                  path: 'basic',
                  element: <ReactTableBasic />
                },
                {
                  path: 'sorting',
                  element: <ReactTableSorting />
                },
                {
                  path: 'filtering',
                  element: <ReactTableFiltering />
                },
                {
                  path: 'grouping',
                  element: <ReactTableGrouping />
                },
                {
                  path: 'pagination',
                  element: <ReactTablePagination />
                },
                {
                  path: 'row-selection',
                  element: <ReactTableRowSelection />
                },
                {
                  path: 'expanding',
                  element: <ReactTableExpanding />
                },
                {
                  path: 'editable',
                  element: <ReactTableEditable />
                },
                {
                  path: 'drag-drop',
                  element: <ReactTableDragDrop />
                },
                {
                  path: 'column-hiding',
                  element: <ReactTableColumnHiding />
                },
                {
                  path: 'umbrella',
                  element: <ReactTableUmbrella />
                }
              ]
            },
            {
              path: 'mui-table',
              children: [
                {
                  path: 'basic',
                  element: <MuiTableBasic />
                },
                {
                  path: 'dense',
                  element: <MuiTableDense />
                },
                {
                  path: 'enhanced',
                  element: <MuiTableEnhanced />
                },
                {
                  path: 'datatable',
                  element: <MuiTableDatatable />
                },
                {
                  path: 'custom',
                  element: <MuiTableCustom />
                },
                {
                  path: 'fixed-header',
                  element: <MuiTableFixedHeader />
                },
                {
                  path: 'collapse',
                  element: <MuiTableCollapse />
                }
              ]
            }
          ]
        },
        {
          path: 'charts',
          children: [
            {
              path: 'apexchart',
              element: <ChartApexchart />
            },
            {
              path: 'org-chart',
              element: <ChartOrganization />
            }
          ]
        },
        {
          path: 'sample-page',
          element: <SamplePage />
        },
        {
          path: 'pricing',
          element: <PricingPage />
        }
      ]
    },
    {
      path: '/maintenance',
      element: <CommonLayout />,
      children: [
        {
          path: '404',
          element: <MaintenanceError />
        },
        {
          path: '500',
          element: <MaintenanceError500 />
        },
        {
          path: 'under-construction',
          element: <MaintenanceUnderConstruction />
        },
        {
          path: 'coming-soon',
          element: <MaintenanceComingSoon />
        }
      ]
    },
    {
      path: '/auth',
      element: <CommonLayout />,
      children: [
        {
          path: 'login',
          element: <AuthLogin />
        },
        {
          path: 'register',
          element: <AuthRegister />
        },
        {
          path: 'forgot-password',
          element: <AuthForgotPassword />
        },
        {
          path: 'reset-password',
          element: <AuthResetPassword />
        },
        {
          path: 'check-mail',
          element: <AuthCheckMail />
        },
        {
          path: 'code-verification',
          element: <AuthCodeVerification />
        }
      ]
    },
    {
      path: '/',
      element: <CommonLayout layout="simple" />,
      children: [
        {
          path: 'contact-us',
          element: <AppContactUS />
        }
      ]
    }
  ]
};

export default MainRoutes;
